import { RootAppState } from 'store/types';

export const getTimerStatus = (state: RootAppState) => state.timer?.status;

export const getTimerElapsed = (state: RootAppState) => state.timer?.elapsed;
